import React, { useEffect, useState, useRef } from 'react';
import { Menu, Row, Col, Card } from 'antd';
import styled from 'styled-components';
import GlossaryRelatedNodesResult, { RelatedNodeTypes } from './GlossaryRelatedNodesResult';
import { useEntityData } from '../shared/EntityContext';
import { ANTD_GRAY } from '../shared/constants';

const CardWrapper = styled(Card)`
    border-right: 1px solid ${ANTD_GRAY[4]} !important;
`;

const MenuWrapper = styled(Menu)`
    &.ant-menu-inline {
        border-right: none;
    }
`;

export default function GlossaryRelatedNode() {
    const { entityData } = useEntityData();
    const [selectedKey, setSelectedKey] = useState('');
    const [isAllLoaded, setIsAllLoaded] = useState(false);
    const menuOptionsArray = Object.keys(RelatedNodeTypes);

    const termsLoadingRef = useRef<Record<string, boolean>>({});

    useEffect(() => {
        if (menuOptionsArray && menuOptionsArray.length > 0 && selectedKey.length === 0) {
            setSelectedKey(menuOptionsArray[0]);
        }
    }, [menuOptionsArray, selectedKey]);

    const onMenuClick = ({ key }) => {
        setSelectedKey(key);
    };

    const trackTermLoading = (urn: string, trackLoading: boolean) => {
        termsLoadingRef.current[urn] = trackLoading;

        const allTermsLoaded = Object.values(termsLoadingRef.current).every((isLoading) => !isLoading);
        setIsAllLoaded(allTermsLoaded);
    };

    return (
        <Row>
            <Col xs={24} lg={4}>
                <CardWrapper className="fill-height ">
                    <MenuWrapper
                        mode="inline"
                        selectable={false}
                        selectedKeys={[selectedKey]}
                        onClick={(key) => {
                            onMenuClick(key);
                        }}
                    >
                        {menuOptionsArray.map((option) => (
                            <Menu.Item data-testid={option} key={option} tabIndex={0}>
                                {RelatedNodeTypes[option]}
                            </Menu.Item>
                        ))}
                    </MenuWrapper>
                </CardWrapper>
            </Col>
            <Col xs={24} lg={20} className="f-pl-1-xs">
                {selectedKey && entityData && (
                    <GlossaryRelatedNodesResult
                        loading={!isAllLoaded}
                        trackTermLoading={trackTermLoading}
                        glossaryRelatedNodeType={RelatedNodeTypes[selectedKey]}
                        glossaryRelatedNodeResult={
                            entityData[selectedKey]?.relationships || entityData[selectedKey]?.nodes || []
                        }
                    />
                )}
            </Col>
        </Row>
    );
}
